import ListDataViewer from "./ListDataViewer.js";
import EditListSettingsAction from "./actions/EditListSettingsAction.js";
import ResultsCountAction from "./actions/ResultsCountAction.js";
export default {
  install(molten) {
    molten.addPlugin('DataViewer', ListDataViewer);
    molten.addPlugin('Action', EditListSettingsAction);
    molten.addPlugin('Action', ResultsCountAction);
  }
};